import React, { useEffect, useState } from 'react'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import { SplitButton } from '../../../common/SplitButton'
import UserWithTransactionrightReportTable from './userWithTransRightReportTable'
import { connect } from 'react-redux'
import { getLRPenaltyReportFilterData, getUserWithTransRightReportTableData, getOwnChildBranches } from '../../../../store/reports/reports_action'
import moment from 'moment'
import { focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import { getCityList, updateAlertError } from '../../../../store/common/common_action'
import { PaymentTypesOptions, urls } from '../../../common/constants'
import { useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { GetRequest, GetRequestCachedV3 } from '../../../common/api'
import { ColumnUserwithTransRightReport, headerFilterColumnUserwithTransRightReport } from '../common/reportConstants'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../helpers/useTokens'
import { downloadPDF } from '../analysisReport/pdfAutotable'
const UserWithTransactionRightReport = (props) => {
    const { data: { common, reports }, getUserWithTransRightReportTableData, updateAlertError, getOwnChildBranches, getCityList } = props
    const { loginData: reduxLoginData, companySettings } = common
    const UseToPayAsCOD = companySettings[0]?.UseToPayAsCOD
    const { userWithTransRightReportData } = reports
    const [showReport, setShowReport] = useState(false)
    const [sourceBranchData, setSourceBranchData] = useState([])
    const [sourceCity, setSourceCity] = useState([])
    const [sourceBranch, setSourceBranch] = useState([])
    const [selPaymentType, setSelPaymentType] = useState([])
    const [tableData, setTableData] = useState([])
    const [reportData, setReportData] = useState([]);
    const [sourceCityData, setSourceCityData] = useState([])
    const [ownChildBranches1, setOwnChildBranches1] = useState([])
    const setAlert = useSetAtom(alertAtom)
    const setLoader = useSetAtom(globalLoaderAtom)
    const reportName = 'User With Transaction Right Report'
    const [searchParams] = useSearchParams()

    let { loginData = {} } = useToken()
    let isFromUrl = false
    if (!loginData) {
        loginData = {}
        loginData.intCompanyID = Number(searchParams.get('C') || 0)
        loginData.intBranchCityID = Number(searchParams.get('CT') || 0)
        loginData.strCityName = searchParams.get('CTN') || ''
        loginData.strCompanyName = searchParams.get('CN') || ''
        loginData.intBranchID = Number(searchParams.get('B') || 0)
        loginData.strBranchName = searchParams.get('BN') || ''
        loginData.intUserID = Number(searchParams.get('U') || 0)
        loginData.strUserName = searchParams.get('UN') || ''
        isFromUrl = true
    }
    if (!isEmpty(reduxLoginData)) {
        loginData = reduxLoginData
    }
    const { intCompanyID, intUserID, strCompanyName } = loginData

    const openViewReport = (reportPayload) => {
        const rid = Date.now().toString()
        if (!window.generatedReports) {
            window.generatedReports = {}
        }
        window.generatedReports[rid] = reportPayload
        window.open(`/view-report?rid=${rid}`, '_blank')
    }

    const normalizeReportData = (rows = []) =>
        rows.map((item, index) => ({
            ...item,
            SN: index + 1,
            sn: index + 1,
            dataType: 'entry',
            textColor: {
                BookingRights: item.BookingRights === 'Active' ? 'green' : 'red',
                RefundRights: item.RefundRights === 'Active' ? 'green' : 'red',
                DeliveryRights: item.DeliveryRights === 'Active' ? 'green' : 'red',
            },
            PaymentType:
                UseToPayAsCOD === 1 && item.PaymentTypeId === 2
                    ? 'COD'
                    : item.PaymentTypeId === 7
                        ? 'COD(MANUAL)'
                        : item.PaymentTypeId === 9
                            ? 'COD(DDDV)'
                    : item.PaymentType,
        }))

    useEffect(() => {
        if (PaymentTypesOptions?.length > 0) {
            setSelPaymentType(PaymentTypesOptions[0])
        }
    }, [])

    useEffect(() => {
        if (intCompanyID) {
            const branchData = {
                intUserID: intUserID || 0,
                intCompanyID: intCompanyID,
                intIsActive: 1,
            }
            setLoader(true)
            GetRequestCachedV3(urls.getOwnAndChildBranchList, branchData, true, 24 * 60 * 60 * 1000)
                .then((res) => {
                    setLoader(false)
                    if (res.status !== 'Success') {
                        throw new Error(res?.ErrMessage || 'Request Failed')
                    }
                    const cityRows = res?.Data?.Table1 || []
                    const branchRows = res?.Data?.Table || []
                    if (!Array.isArray(cityRows) || cityRows.length === 0) {
                        throw new Error('No Data Found')
                    }
                    const branchList = Array.isArray(branchRows) ? branchRows.filter((branch) => branch?.BranchID && branch?.BranchName) : []
                    setOwnChildBranches1(branchList)

                    const uniqueCities = removeDuplicatesFromArray(
                        cityRows
                            .filter((val) => val?.CityID && val?.CityName)
                            .map((val) => ({ CityName: val.CityName, CityID: val.CityID })),
                        'CityID'
                    )
                    setSourceCityData([{ CityID: 0, CityName: 'All' }, ...uniqueCities])

                    const matchedCity = uniqueCities.find((obj) => obj.CityID === Number(loginData?.intBranchCityID))
                    const defaultCity = matchedCity || uniqueCities[0] || { CityID: 0, CityName: 'All' }
                    setSourceCity(
                        matchedCity
                            ? { CityID: Number(loginData?.intBranchCityID), CityName: loginData?.strCityName }
                            : defaultCity
                    )

                    const filteredBranches = [{ BranchID: 0, BranchName: 'All' }, ...branchList]
                        .filter((branch) => branch.CityID === Number(defaultCity?.CityID || 0) || Number(defaultCity?.CityID || 0) === 0 || branch.BranchID === 0)
                    setSourceBranchData(filteredBranches)
                    const matchedBranch = filteredBranches.find((obj) => obj.BranchID === Number(loginData?.intBranchID))
                    setSourceBranch(
                        matchedBranch
                            ? { BranchID: Number(loginData?.intBranchID), BranchName: loginData?.strBranchName }
                            : filteredBranches[0] || { BranchID: 0, BranchName: 'All' }
                    )
                })
                .catch((err) => {
                    setAlert({ show: true, msg: err.message, nextId: '' })
                })
                .finally(() => setLoader(false))
        }
    }, [intCompanyID, intUserID])
    useEffect(() => {
        if (userWithTransRightReportData?.length > 0) {
            let data = userWithTransRightReportData
            console.log(data, 'data')
            data = data.map((item, index) => ({
                ...item,
                sn: index + 1,

            }));
            setTableData(data)
            setReportData(data)
        } else {
            setTableData([])
            setReportData([])
        }
    }, [userWithTransRightReportData])
    useEffect(() => {
        focusElemnt('fromDate')
    }, [])
    // const generateReport = () => {
    //     if (sourceCity == '' || sourceCity == ' ') {
    //         updateAlertError({ show: true, msg: 'Select City', nextId: '' })
    //     } else if (sourceBranch == "" || sourceBranch == ' ') {
    //         updateAlertError({ show: true, msg: 'Select Branch', nextId: '' })
    //     }
    //     else if (selPaymentType == "" || selPaymentType == ' ') {
    //         updateAlertError({ show: true, msg: 'Select Payment Type', nextId: '' })
    //     } else {
    //         setShowReport(true)
    // const obj = {
    //     CityID: sourceCity?.CityID || 0,
    //     BranchID: sourceBranch?.BranchID || 0,
    //     PaymentTypeID: selPaymentType?.id || 0,
    //     CompanyID: loginData?.intCompanyID,
    // }
    //         getUserWithTransRightReportTableData(obj,UseToPayAsCOD)
    //     }
    // }
    const filterHeaderData = {
        company: loginData?.strCompanyName,
        city: sourceCity?.CityName,
        branch: sourceBranch?.BranchName,
        paymentType: selPaymentType?.Name,
        dataType: 'entry',
    }
    const generateReport = (isPdf = false) => {
        if (sourceCity == '' || sourceCity == ' ') {
            setAlert({ show: true, msg: 'Select City', nextId: '' })
            return
        }
        setLoader(true)
        const obj = {
            CityID: sourceCity?.CityID || 0,
            BranchID: sourceBranch?.BranchID || 0,
            PaymentTypeID: selPaymentType?.id || 0,
            CompanyID: loginData?.intCompanyID,
        }
        GetRequest(urls.getUserWithTransRightReportTableData, obj)
            .then((res) => {
                if (res.status !== 'Success') {
                    throw new Error(res?.ErrMessage || 'Request Failed')
                }
                if (!Array.isArray(res.Table) || res.Table.length === 0) {
                    throw new Error('No Data Found')
                }
                const updatedData = normalizeReportData(res?.Table)
                const reportPayload = {
                    reportName,
                    criteriaHeaders: headerFilterColumnUserwithTransRightReport,
                    criteriaData: [filterHeaderData],
                    tableData: updatedData,
                    mainHeader: ColumnUserwithTransRightReport,
                    isShowManageColumn: false,
                    manageColumnID: '',
                    hideHeader: false,
                    serialNokey: 'SN',
                }
                if (isPdf) {
                    downloadPDF({
                        reportName,
                        criteriaHeaders: headerFilterColumnUserwithTransRightReport.map((item) => ({
                            ...item,
                            header: item.header || item.headerName,
                        })),
                        criteriaData: [filterHeaderData],
                        tableData: updatedData,
                        visibleColumns: ColumnUserwithTransRightReport,
                        loginData,
                        hideHeader: false,
                    })
                    return
                }
                openViewReport(reportPayload)
            })
            .catch((err) => {
                setAlert({ show: true, msg: err.message, nextId: '' })
            })
            .finally(() => setLoader(false))
    }

    const selectedSourceCity = (obj) => {
        setShowReport(false)
        setSourceCity(obj)
        if (obj?.CityID === 0) {
            const branchListWithAll = [{ BranchID: 0, BranchName: 'All' }, ...ownChildBranches1];
            setSourceBranchData(branchListWithAll);
            setSourceBranch(branchListWithAll[0])
        } else {
            const filteredBranches = ownChildBranches1?.filter((val) => Number(val?.CityID) === Number(obj?.CityID));
            const branchListWithAll = [{ BranchID: 0, BranchName: 'All' }, ...filteredBranches];
            setSourceBranchData(branchListWithAll);
            setSourceBranch(branchListWithAll[0])

        }
    }
    return (
        <>
            <Item sx={{ padding: '0' }} className="reports">
                {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
                {isFromUrl ? <></> : <ReportHeading reportName={reportName} />}
                <Box sx={{ ...sx.reportFlex, justifyContent: 'start' }}>
                    {isFromUrl ? <></> : <>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            label={"Select Company"}
                            defaultvalue={strCompanyName}
                            disabled={true}
                            width="300px"
                        />{' '}
                    </Item>
                    <Item sx={sx.itemsx} className="disabled-wrapper">
                        <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary" >
                            GO
                        </Button>
                    </Item></>}
                    <Item sx={sx.itemsxGrow}>
                        <DropDownOA
                            label={`Select City`}
                            id={'selectCity'}
                            data={sourceCityData || []}
                            defaultvalue={sourceCity?.CityName || sourceCity}
                            dataKey={`CityName`}
                            idKey={`CityID`}
                            onSelect={(obj) => { selectedSourceCity(obj) }}
                            width="100%"
                            nextId={'selectedBranch'}
                            prevId={'goButtonDate'}
                        />
                    </Item>
                    <Item sx={sx.itemsxGrow}>
                        <DropDownOA
                            id={'selectedBranch'}
                            label={'Select Branch'}
                            // data={roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 1 && roleRights?.Table1?.[0]?.AllowViewAllBranchReport == 0 ? ownChildBranches.filter((val) => val.SourceBranchID == loginData?.intBranchCityID) : ownChildBranches || []}
                            data={sourceBranchData || []}
                            searchPlaceholder={`Search By Branch`}
                            defaultvalue={sourceBranch?.BranchName || sourceBranch}
                            dataKey={`BranchName`}
                            idKey={`BranchID`}
                            onSelect={(val) => { setShowReport(false); setSourceBranch(val) }}
                            onReset={() => setSourceBranch('')}
                            nextId={'generateButton'}
                            prevId={'paymentType'}
                            width="100%"
                        />
                    </Item>
                    <Item sx={sx.itemsxGrow}>
                        <DropDownOA
                            label={`Payment Type`}
                            id={'paymentType'}
                            // data={PaymentTypesOptions}
                            data={(PaymentTypesOptions || []).map((item) => {
                                if (UseToPayAsCOD === 1) {
                                    if (item.id === 2) {
                                        return { ...item, Name: 'COD' };
                                    }
                                    if (item.id === 7) {
                                        return { ...item, Name: 'COD Manual' };
                                    }
                                    if (item.id === 9) {
                                        return { ...item, Name: 'COD DDDV' };
                                    }
                                    if (item.id === 4) {
                                        return null;
                                    }
                                }
                                return item;
                            }).filter(Boolean)
                            }
                            defaultvalue={selPaymentType?.Name || selPaymentType}
                            searchPlaceholder={`Search By Payment`}
                            HasAllSelect={true}
                            dataKey={`Name`}
                            idKey={`id`}
                            onSelect={(val) => {
                                setSelPaymentType(val)
                            }} width="100%"
                            nextId={'generateButton'}
                            prevId={'selectedBranch'}
                        />
                    </Item>
                    <Item sx={sx.itemsxGrow}
                        onKeyDown={(e) => { navigation3(e, showReport ? "ExpToExlbtn" : 'fromDate', 'selectedBranch', () => generateReport()) }}
                    >
                        {isFromUrl ? (
                            <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => generateReport(true)}>
                                DOWNLOAD PDF
                            </Button>
                        ) : (
                            <SplitButton
                                options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                                id1={'generateButton'}
                                onClick1={() => generateReport(false)}
                            />
                        )}
                    </Item>
                </Box>
            </Item>
            {
                showReport ? <UserWithTransactionrightReportTable tableData={tableData} loginData={loginData} sourceCity={sourceCity} sourceBranch={sourceBranch} selPaymentType={selPaymentType} setTableData={setTableData} reportData={reportData} /> : ''
            }
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getLRPenaltyReportFilterData, getUserWithTransRightReportTableData, updateAlertError, getOwnChildBranches, getCityList }
export default connect(mapStateToProps, mapDispatchToProps)(UserWithTransactionRightReport)
